export const BATCHES_DEBOUNCE_MS = 500;

export const BATCHES_EXPORT_POLL_INTERVAL_MS = 3000;

export const BATCHES_EXPORT_MAX_POLLS = 100;

export const PARTIAL_BATCH_MISSING_VALUE_NOTE =
  "Highlighted fields indicate missing values in this partial batch.";

export const PARTIAL_BATCH_MISSING_VALUE_COLORS = {
  background: "#FEF3F2",
  border: "#D92D20",
  text: "#B42318",
};



export const BATCHES_TABLE_HEADERS = [
  "", // ✅ Checkbox column
  "Sr No.",
  null,
  "Batch ID",
  "Date of Manufacture",
  // "Metadata Status",
  "Batch Status",
  "Source",
  "Action",
];



export const PARTIAL_DATA_TABLE_HEADERS = [
  { label: "Sr No.", width: "7%" },
  { label: "Unit Operation", width: "19%", sortKey: "unit_operation" },
  { label: "Batch ID", width: "14%", sortKey: "batch_id" },
  { label: "Date of Manufacture", width: "18%", sortKey: "batch_date" },
  {
    label: "Missing Parameter Count",
    width: "17%",
    sortKey: "missing_parameters_count",
  },
  { label: "Missing Parameter Names", width: "25%" },
];
